/** Matches values that start with a known Tiptap block tag (output from the editor). */
const TIPTAP_HTML_RE = /^\s*<(p|ul|ol|li|h[1-6]|blockquote)[\s>]/i;

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/**
 * Converts legacy plain-text conclusion values to HTML for Tiptap.
 * Detects "- item" bullet format and wraps in `<ul>`.
 * Already-HTML values pass through unchanged.
 */
export function plainTextToHtml(value: string): string {
  if (!value || !value.trim()) return '';

  // Already Tiptap HTML — pass through
  if (TIPTAP_HTML_RE.test(value)) return value;

  const lines = value.split(/\r?\n/).filter((l) => l.trim() !== '');
  const allBullets = lines.every((l) => l.trim().startsWith('-'));

  if (allBullets && lines.length > 0) {
    const items = lines
      .map((l) => l.replace(/^-\s*/, '').trim())
      .filter(Boolean)
      .map((text) => `<li><p>${escapeHtml(text)}</p></li>`)
      .join('');
    return `<ul>${items}</ul>`;
  }

  // Plain text without bullet format — wrap paragraphs
  return lines.map((l) => `<p>${escapeHtml(l.trim())}</p>`).join('');
}
